export const tokenKey = 'citrustoken'
export const signatureKey = 'citrussignature'
